import { useMemo } from "react";
import Table, { TableColumns } from "../../components/table";
import { RetailOdDrawdownLoanRepaymentSplit } from "../../dto";
import { dateToDDMMYYYY } from "../../utils";

const RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SPLIT_TABLE_COLUMNS: TableColumns[] = [
  { label: "Payment Date", field: "paidAt", style: { textAlign: "center" } },
  { label: "Amount", field: "amount", style: { textAlign: "center" } },
  {
    label: "Principal Paid",
    field: "totalPrincipalPaid",
    style: { textAlign: "center" },
  },
  {
    label: "Interest Paid",
    field: "totalInterestPaid",
    style: { textAlign: "center" },
  },
  {
    label: "Closing Balance",
    field: "closingBalance",
    style: { textAlign: "center" },
  },
  { label: "Reported On", field: "reportedAt", style: { textAlign: "center" } },
];

function getTableDataForRetailOdDrawdownLoanRepaymentSplit(
  data: RetailOdDrawdownLoanRepaymentSplit[]
) {
  return data.map(
    ({
      paidAt,
      reportedAt,
      amount,
      closingBalance,
      totalInterestPaid,
      totalPrincipalPaid,
    }) => ({
      paidAt: dateToDDMMYYYY(paidAt),
      reportedAt: dateToDDMMYYYY(reportedAt),
      amount: amount.toFixed(2),
      closingBalance: closingBalance.toFixed(2),
      totalInterestPaid: totalInterestPaid.toFixed(2),
      totalPrincipalPaid: totalPrincipalPaid.toFixed(2),
    })
  );
}

interface RetailOdDrawdownRepaymentSplitProps {
  data: RetailOdDrawdownLoanRepaymentSplit[] | null;
  isLoading: boolean;
}

export default function RetailOdDrawdownRepaymentSplit({
  data,
  isLoading,
}: RetailOdDrawdownRepaymentSplitProps) {
  const tableDataForRetailOdDrawdownLoanRepaymentSplit = useMemo(() => {
    if (!data) return [];
    return getTableDataForRetailOdDrawdownLoanRepaymentSplit(data);
  }, [data]);

  if (!data) return null;

  return (
    <>
      <h3 className="user-page-title mb-4">Payment History</h3>
      <Table
        columns={RETAIL_OD_DRAWDOWN_LOAN_REPAYMENT_SPLIT_TABLE_COLUMNS}
        data={tableDataForRetailOdDrawdownLoanRepaymentSplit}
        loading={isLoading}
      />
    </>
  );
}
